import { useQueryClient } from 'react-query';

import { useCustomSnackBar } from 'hooks/useCustomSnackBar';

export const useAssigneeCellLogic = ({ api, riskId }: { api: any; riskId: number }) => {
    const { handleSnackBar } = useCustomSnackBar();
    const queryClient = useQueryClient();

    const updateAssignee = (value) => {
        api.updateRiskProperty.instance.mutate(
            {
                id: riskId,
                assignee: value,
            },
            {
                onSuccess: () => {
                    queryClient.invalidateQueries('getRiskRegister').then(() => {
                        handleSnackBar('Risk register updated successfully', 'success');
                    });
                },
                onError: () => {
                    handleSnackBar('Failed to update risk register', 'error');
                },
            },
        );
    };
    return { logic: { updateAssignee } };
};
